import swal from "sweetalert";
import Api from "./Api";

const useSave = (url = ``, inputs = {}, config = {}) => {
  return new Promise((resolve, reject) => {
    let data;
    let headers;

    if (inputs instanceof FormData) {
      data = inputs;
      headers = { ...config.headers }; // Don't set Content-Type header, let the browser set it
    } else {
      data = JSON.stringify(inputs);
      headers = { 'Content-Type': 'application/json', ...config.headers };
    }

    Api.post(url, data, { headers })
      .then((response) => {
        if (response.data.resultCode === "00") {
          swal("", "saved", "success");
          resolve(response.data);
        } else {
          swal("", response.data.description, "error");
         // reject(response.data);
        }
      })
      .catch((error) => {
        swal("", "Failed", "error");
        reject(error);
      });
  });
};

export default useSave;
